import { ThirdPartyBillingAccountSchema } from "@redotech/redo-model/outbound-labels/third-party-billing-accounts";
import * as z from "zod/v4";

export const getThirdPartyBillingAccounts = {
  name: "getThirdPartyBillingAccounts" as const,
  input: z.null(),
  output: z.object({ accounts: z.array(ThirdPartyBillingAccountSchema) }),
};
